import * as endpoints from './endpoints';

const CarePlanService = { ...endpoints };

export default CarePlanService;
export type { CarePlan } from './endpoints';
